var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "transparent",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3331 17.0666L18.9331 24.5333C19.4664 25.0666 20.2664 25.0666 20.7998 24.5333C21.3331 24 21.3331 23.2 20.7998 22.6666L14.2664 16L20.7998 9.33332C21.3331 8.79998 21.3331 7.99998 20.7998 7.46665C20.5331 7.19998 20.2664 7.06665 19.8664 7.06665C19.4664 7.06665 19.1998 7.19998 18.9331 7.46665L11.3331 14.9333C10.7998 15.6 10.7998 16.4 11.3331 17.0666C11.3331 16.9333 11.3331 16.9333 11.3331 17.0666Z",
    fill: "#51459E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.755865104058ce499166deea2d8845cf.svg";
export { ForwardRef as ReactComponent };